import { useDispatch, useSelector } from 'react-redux';

import { LoadingStatus } from 'src/constants/loading-status';
import { useIntl } from 'src/hooks/intl';
import { changeFilterState } from 'src/redux/jira/actions';
import { FilterState, Site } from 'src/redux/jira/types';
import { BucketState } from 'src/types/state';

import { SingleSelectFilterDropdown } from '../filter-dropdown';

import messages from './relevant-sites-filter.i18n';

export const RelevantSitesFilter = () => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const filterState = useSelector<BucketState, FilterState>(
    state => state.jira.jiraRepoPage.filterState
  );
  const { siteCloudId } = filterState;
  const relevantSites = useSelector<BucketState, Site[]>(
    state => state.jira.jiraRepoPage.relevantSites
  );
  const relevantSitesFetchedStatus = useSelector<BucketState, LoadingStatus>(
    state => state.jira.jiraRepoPage.relevantSitesFetchedStatus
  );
  const isLoading =
    relevantSitesFetchedStatus !== LoadingStatus.Success &&
    relevantSitesFetchedStatus !== LoadingStatus.Failed;

  const handleChange = (selectedSite: string) => {
    dispatch(
      changeFilterState({
        siteCloudId: String(selectedSite),
      })
    );
  };

  const options = relevantSites.map(site => ({
    label: site.cloudName,
    value: site.cloudId,
  }));

  const shouldShow =
    relevantSites.length > 1 ||
    // Selected site is not part of options. That can happen if user visits an old URL (where the site has been unlinked).
    // In that case, show the dropdown so that the user can switch to a different site.
    (relevantSites.length === 1 && relevantSites[0].cloudId !== siteCloudId);

  return shouldShow ? (
    <SingleSelectFilterDropdown
      isLoading={isLoading}
      label={intl.formatMessage(messages.relevantSitesDropdownTrigger)}
      onChange={handleChange}
      options={options}
      optionsTitle={intl.formatMessage(messages.relevantSitesDropdownHeading)}
      selected={siteCloudId}
      triggerAppearance="default"
    />
  ) : null;
};
